import { render, staticRenderFns } from "./Envelope.vue?vue&type=template&id=b4915b4c&scoped=true"
import script from "./Envelope.vue?vue&type=script&lang=js"
export * from "./Envelope.vue?vue&type=script&lang=js"
import style0 from "./Envelope.vue?vue&type=style&index=0&id=b4915b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4915b4c",
  null
  
)

export default component.exports